import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'src/utils/dayjs';
import { Box, Button, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useTranslation } from 'react-i18next';
import Dialog from 'src/components/Dialog/Dialog';

const CutoffDateDialog = ({ open, cutoffDate, handleClose, handleApply }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(cutoffDate || dayjs.tz());

  useEffect(() => {
    if (open) {
      setValue(cutoffDate || dayjs.tz());
    }
  }, [open, cutoffDate]);

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      title={t('TRANSACTION.CUTOFF_DATE')}
    >
      <Box sx={{ padding: '0 24px 8px' }}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ marginBottom: 2 }}
        >
          {t('TRANSACTION.CUTOFF_DATE_DIALOG_SUBTITLE')}
        </Typography>
        <DatePicker
          label={t('TRANSACTION.ACCOUTING_STATE_UNTIL')}
          value={value}
          locale="en"
          minDate={dayjs.tz().subtract(5, 'years')}
          onChange={setValue}
          slotProps={{ textField: { sx: { width: '100%' } } }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1,
          padding: '16px 24px'
        }}
      >
        <Button onClick={handleClose}>{t('COMMON.CANCEL')}</Button>
        <Button variant="contained" color="primary" onClick={() => handleApply(value)}>
          {t('TRANSACTION.APPLY_CUTOFF_DATE')}
        </Button>
      </Box>
    </Dialog>
  );
};

CutoffDateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  cutoffDate: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  handleApply: PropTypes.func.isRequired
};

CutoffDateDialog.defaultProps = {
  cutoffDate: null
};

export default CutoffDateDialog;
